module.exports = __webpack_public_path__ + "static/img/govermment.d4608ec0.png";